<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tittle"><span>Author’s Preface</span></p>
<p class="normal">The tales which follow were written over the last ten years, sometimes to commission, sometimes on a whim, sometimes in an effort to work a fit of bad temper from my system, but always with the entertainment of a particular friend in mind. Some have been published before, as detailed below, but to tinker is only human, so they now appear in a slightly altered form.</p>
<p class="hang-indent">Wig – <i>His</i> (Faber and Faber, US)</p>
<p class="hang-indent1">Dressing Up In Voices – <i>Twenty Under Thirty</i> (Sceptre)</p>
<p class="hang-indent1">Borneo – <i>Whitbread Stories One</i> (Jonathan Cape)</p>
<p class="hang-indent1">Other Men’s Sweetness – <i>The Ten Commandments</i> (Serpent’s Tail)</p>
<p class="hang-indent1">Old Boys – <i>Meanwhile In Another Part of the Forest</i> (Flamingo)</p>
<p class="hang-indent1">The List – <i>The Faber Book of Gay Short Stories</i> (Faber and Faber)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?bfcd46e6